import { useContext } from 'react';

import { AgentContext } from '@contexts/AgentContext';

export const useAgents = () => {
    const context = useContext(AgentContext);
    if (context === undefined) {
        throw new Error('useAgents must be used within an AgentProvider');
    }
    return context;
};